/* ==========================================================================
   Koolseed — Header panelleri
   Menü, arama ve sepet panellerini tek bir durum makinesiyle yönetir:
   aynı anda yalnızca biri açık olabilir.
   ========================================================================== */

(function () {
  'use strict';

  /* Arkasında karartma olmayan paneller. Menü zaten opak ve header'ın altını
     tamamen kaplıyor; arkasına karartma koyunca yarı saydam header sönük
     görünüyordu. */
  const NO_SCRIM = new Set(['search', 'menu']);
  /* Sayfa kilidi uygulanmayan paneller — arama küçük bir açılır kutu. */
  const LIGHT_PANELS = new Set(['search']);

  class KsHeader extends HTMLElement {
    connectedCallback() {
      this.panels = new Map();
      this.openName = null;
      this.releaseFocus = null;

      // Panel gövdeleri header'ın dışında da olabilir (sepet drawer'ı gibi).
      document.querySelectorAll('[data-ks-panel]').forEach((panel) => {
        this.panels.set(panel.dataset.ksPanel, panel);
      });

      this.scrim = document.querySelector('[data-ks-scrim]');
      this.triggers = Array.from(document.querySelectorAll('[data-ks-toggle]'));

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          const name = trigger.dataset.ksToggle;

          // Sepet "sayfa" modundaysa bağlantı normal davransın.
          if (name === 'cart' && this.dataset.cartType !== 'drawer') return;
          if (!this.panels.has(name)) return;

          event.preventDefault();
          this.toggle(name, trigger);
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.openName) this.close();
      });

      if (this.scrim) this.scrim.addEventListener('click', () => this.close());

      // Karartması olmayan paneller dışarı tıklanınca kapansın.
      document.addEventListener('pointerdown', (event) => {
        if (!this.openName || !LIGHT_PANELS.has(this.openName)) return;
        const panel = this.panels.get(this.openName);
        if (!panel || panel.contains(event.target)) return;
        if (event.target.closest('[data-ks-toggle]')) return; // tetikleyici zaten toggle ediyor
        this.close();
      });

      document.querySelectorAll('[data-ks-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });

      // Sepete ekleme sonrası drawer'ı açmak için ortak olay.
      document.addEventListener('ks:cart:open', () => this.open('cart'));
      document.addEventListener('ks:panel:close', () => this.close());

      this.syncHeaderHeight();
      window.addEventListener('resize', window.KS.debounce(() => this.syncHeaderHeight(), 150));

      this.initAutoHide();
    }

    /* ---- Kaydırmada gizlenen header ---------------------------------------
       Aşağı kaydırınca duyuru çubuğu + header birlikte yukarı kayıp
       gizleniyor, yukarı kaydırınca geri geliyor.

       Yanıp sönmeyi (bir görün bir kaybol döngüsünü) engelleyen üç kural:
         · Histerezis — yön değiştikten sonra durum değişmeden önce o yönde
           en az THRESHOLD kadar yol alınmış olmalı. Küçük titremeler ve
           trackpad geri tepmeleri durumu değiştirmiyor.
         · Tepede sabit — header'ın kendi boyu kadar alanda asla gizlenmiyor.
         · Sınır kelepçesi — iOS'taki esneme (negatif / aşırı scrollY)
           değerleri kırpılıyor, yoksa bounce sırasında yön sürekli dönüyor.

       Panel açıkken, klavye odağı header'ın içindeyken ve mobil klavye
       yüzünden sayfa kısaldığında header sabit kalıyor. */
    initAutoHide() {
      const topbar = document.querySelector('[data-ks-topbar]');
      if (!topbar || !this.classList.contains('ks-header-root--sticky')) return;

      this.topbar = topbar;
      const THRESHOLD = 8;

      let hidden = false;
      let ticking = false;
      let direction = 0;
      let lastY = window.scrollY;
      let anchorY = lastY;

      const setHidden = (next) => {
        if (next === hidden) return;
        hidden = next;
        topbar.classList.toggle('is-hidden', next);
        document.body.classList.toggle('is-topbar-hidden', next);
      };
      this.revealHeader = () => setHidden(false);

      const update = () => {
        ticking = false;

        const max = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
        const y = Math.min(Math.max(window.scrollY, 0), max);
        const delta = y - lastY;
        if (delta === 0) return;

        const dir = delta > 0 ? 1 : -1;
        if (dir !== direction) {
          direction = dir;
          anchorY = lastY; // yön döndü: ölçümü buradan başlat
        }
        lastY = y;

        // Header'ın kendi yüksekliği kadar alanda her zaman görünür.
        if (y <= topbar.offsetHeight + 20) { setHidden(false); return; }
        // Panel açıkken ya da odak header'ın içindeyken kaçmasın.
        if (this.openName || topbar.contains(document.activeElement)) { setHidden(false); return; }

        if (Math.abs(y - anchorY) < THRESHOLD) return;
        setHidden(dir === 1);
      };

      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }, { passive: true });

      // Sayfa içi bağlantıyla atlandığında header hemen görünsün.
      window.addEventListener('hashchange', () => { lastY = window.scrollY; setHidden(false); });
    }

    /** Sticky yükseklikleri CSS'e bildirir; paneller header'ın altından başlar. */
    syncHeaderHeight() {
      const announcement = document.querySelector('.ks-announcement');
      const bar = this.querySelector('.ks-header__bar');
      const root = document.documentElement;

      root.style.setProperty('--ks-announcement-h', `${announcement ? announcement.offsetHeight : 0}px`);
      if (bar) root.style.setProperty('--ks-header-h', `${bar.offsetHeight}px`);
    }

    toggle(name, trigger) {
      if (this.openName === name) this.close();
      else this.open(name, trigger);
    }

    open(name, trigger) {
      const panel = this.panels.get(name);
      if (!panel) return;

      if (this.openName) this.close({ keepLock: true });

      this.openName = name;
      this.openTrigger = trigger || this.triggers.find((t) => t.dataset.ksToggle === name);

      // Panel açıkken header kaymasın: paneller header'ın altından başlıyor.
      if (this.revealHeader) this.revealHeader();
      if (this.topbar) this.topbar.classList.add('is-pinned');

      panel.hidden = false;
      // Görünürlük geçişinin çalışması için bir frame bekle.
      window.requestAnimationFrame(() => panel.classList.add('is-open'));

      // Arama paneli hafif bir açılır kutu: tasarımda arkasında karartma yok,
      // sayfa da kilitlenmiyor. Menü ve sepet ise modal davranıyor.
      const light = LIGHT_PANELS.has(name);

      if (this.scrim && !NO_SCRIM.has(name)) {
        this.scrim.hidden = false;
        window.requestAnimationFrame(() => this.scrim.classList.add('is-open'));
      }

      document.body.classList.add(`ks-panel-open`, `ks-panel-${name}`);
      if (light) {
        // Modal bir panelden hafif panele geçilmişse kilit devrede kalmasın.
        if (this._locked) {
          window.KS.lockScroll(false);
          this._locked = false;
        }
      } else if (!this._locked) {
        window.KS.lockScroll(true);
        this._locked = true;
      }

      if (this.openTrigger) this.openTrigger.setAttribute('aria-expanded', 'true');

      const initial =
        panel.querySelector('[data-ks-autofocus]') ||
        panel.querySelector('input:not([type="hidden"])') ||
        panel.querySelector('[data-ks-close]');

      if (light) {
        // Odak tuzağı yok — kutunun dışına sekerek çıkılabilsin.
        if (initial) initial.focus({ preventScroll: true });
      } else {
        this.releaseFocus = window.KS.trapFocus(panel, initial);
      }

      this.dispatchEvent(new CustomEvent('ks:panel:opened', { detail: { name }, bubbles: true }));
    }

    close(options) {
      const name = this.openName;
      if (!name) return;
      const panel = this.panels.get(name);

      if (this.releaseFocus) {
        this.releaseFocus();
        this.releaseFocus = null;
      }

      panel.classList.remove('is-open');
      if (this.scrim) this.scrim.classList.remove('is-open');
      document.body.classList.remove('ks-panel-open', `ks-panel-${name}`);

      if (this.openTrigger) {
        this.openTrigger.setAttribute('aria-expanded', 'false');
        this.openTrigger.focus({ preventScroll: true });
      }

      this.openName = null;
      if (this.topbar && !(options && options.keepLock)) this.topbar.classList.remove('is-pinned');

      if (!(options && options.keepLock) && this._locked) {
        window.KS.lockScroll(false);
        this._locked = false;
      }

      // Geçiş bitmeden hidden koymak animasyonu kesiyor.
      const finish = () => {
        if (this.openName !== name) {
          panel.hidden = true;
          if (this.scrim && !this.openName) this.scrim.hidden = true;
        }
      };
      const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 320;
      window.setTimeout(finish, duration);
    }
  }

  if (!customElements.get('ks-header')) customElements.define('ks-header', KsHeader);
})();
